export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_RESET = "REGISTER_USER_RESET";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";

// New registration flow (landing parity)
export const NEW_REGISTER_REQUEST = "NEW_REGISTER_REQUEST";
export const NEW_REGISTER_SUCCESS = "NEW_REGISTER_SUCCESS";
export const NEW_REGISTER_FAIL = "NEW_REGISTER_FAIL";

export const OTP_VERIFY_REQUEST = "OTP_VERIFY_REQUEST";
export const OTP_VERIFY_SUCCESS = "OTP_VERIFY_SUCCESS";
export const OTP_VERIFY_FAIL = "OTP_VERIFY_FAIL";

export const OTP_RESEND_REQUEST = "OTP_RESEND_REQUEST";
export const OTP_RESEND_SUCCESS = "OTP_RESEND_SUCCESS";
export const OTP_RESEND_FAIL = "OTP_RESEND_FAIL";

export const LOAD_USER_REQUEST = "LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAIL = "LOAD_USER_FAIL";

export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";

export const FORGOT_PASSWORD_OTP_VERIFY_REQUEST = "FORGOT_PASSWORD_OTP_VERIFY_REQUEST";
export const FORGOT_PASSWORD_OTP_VERIFY_SUCCESS = "FORGOT_PASSWORD_OTP_VERIFY_SUCCESS";
export const FORGOT_PASSWORD_OTP_VERIFY_FAIL = "FORGOT_PASSWORD_OTP_VERIFY_FAIL";

export const FORGOT_PASSWORD_OTP_RESEND_REQUEST = "FORGOT_PASSWORD_OTP_RESEND_REQUEST";
export const FORGOT_PASSWORD_OTP_RESEND_SUCCESS = "FORGOT_PASSWORD_OTP_RESEND_SUCCESS";
export const FORGOT_PASSWORD_OTP_RESEND_FAIL = "FORGOT_PASSWORD_OTP_RESEND_FAIL";

export const FORGOT_PASSWORD_RESET = "FORGOT_PASSWORD_RESET";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
